module.exports = __webpack_public_path__ + "static/media/d485ba21.jpg";